import { FarmRiskType, InlandMarineTypes, branchLiveStates } from '@ourbranch/lookups';
const brand = {
    constants: {
        SHORT_NAME: 'Branch',
        FULL_NAME: 'Branch Insurance',
        LEGAL_NAME: 'Branch Insurance Exchange',
        EMAIL_SENDER: 'Branch Insurance',
        EMAIL_BCC: 'sendgridbcc@ourbranch.com',
        SUPPORT_NAME: 'Branch Insurance',
        DOMAIN: 'ourbranch.com',
        SUPPORT_EMAIL: 'support@ourbranch.com',
        DISPLAY_NAME: 'Branch',
        MARKETING_NAME: 'Branch Insurance',
        POLICY_ISSUER: 'Branch Insurance Exchange',
        CLAIMS_HANDLER: 'Branch',
        REFERRAL_NAME: 'Branch Insurance',
        SOCIAL_HANDLE: 'Branch',
        PAYMENT_ADDRESS: 'Branch Payments, PO Box 15010, Worcester, MA 01615',
        EXPEDITED_PAYMENT_ADDRESS: 'Branch c/o Covenir, 370 Main St, Suite 880, Worcester, MA 01608',
        CUSTOMER_SERVICE_PHONE: '833-427-2624',
        CUSTOMER_SERVICE_PHONE_LETTERS: '833-4BRANCH',
        CLAIMS_PHONE: '(855)-223-9294',
        CLAIMS_EMAIL: 'claimsupport@ourbranch.com'
    },
    features: {
        account: {
            policy: {
                showCoveragesTab: true,
                showPolicyInformationTab: true,
                showPriceBreakdownTab: true,
                showDiscountsTab: true,
                showBillingTab: true,
                showDocumentsTab: true
            },
            service: {
                claimsEnabled: true,
                frontChatEnabled: true,
                helpCenterEnabled: true,
                taskCenterEnabled: true
            },
            marketing: {
                referralsEnabled: true,
                showUpsellPage: true
            }
        }
    },
    theme: {
        palette: null,
        loaderColor: '#527059',
        showLogoInLoader: true,
        showAccountBackgroundHero: true,
        logoWidthDesktop: 320,
        logoWidthMobile: 230
    },
    config: {
        supportedStates: branchLiveStates,
        features: {
            hasFutureEffectiveDateDiscount: true,
            hasAdvanceQuoteDiscount: true
        },
        farm: {
            IL: {
                [FarmRiskType.Fo3]: {
                    hiddenCoverages: []
                },
                [FarmRiskType.Fo4]: {
                    hiddenCoverages: [],
                    inlandMarine: {
                        itemTypes: [
                            InlandMarineTypes.BoatDock,
                            InlandMarineTypes.Boats,
                            InlandMarineTypes.CoinCollection,
                            InlandMarineTypes.FineArts,
                            InlandMarineTypes.Furs,
                            InlandMarineTypes.GolfEquipment,
                            InlandMarineTypes.GolfCarts,
                            InlandMarineTypes.Guns,
                            InlandMarineTypes.Jewelry,
                            InlandMarineTypes.LawnMowers,
                            InlandMarineTypes.MiscellaneousProperty,
                            InlandMarineTypes.MusicalInstruments,
                            InlandMarineTypes.PersonalTools,
                            InlandMarineTypes.Silverware,
                            InlandMarineTypes.SportingEquipment,
                            InlandMarineTypes.Tack,
                            InlandMarineTypes.UnmannedAircraft,
                            InlandMarineTypes.Hardware,
                            InlandMarineTypes.Software,
                            InlandMarineTypes.ScheduledGlass
                        ]
                    }
                },
                [FarmRiskType.Fo6Structures]: {
                    hiddenCoverages: [],
                    excludedConstructionTypes: [],
                    businessRules: {
                        buildingClass1MaxAgeYears: 25
                    }
                }
            },
            MO: {
                [FarmRiskType.Fo3]: {
                    hiddenCoverages: []
                },
                [FarmRiskType.Fo4]: {
                    hiddenCoverages: []
                },
                [FarmRiskType.Fo6Structures]: {
                    hiddenCoverages: [],
                    excludedConstructionTypes: ['MH'],
                    businessRules: {
                        buildingClass1MaxAgeYears: 25
                    }
                },
                [FarmRiskType.Fo6Unscheduled]: {
                    hiddenCoverages: []
                },
                [FarmRiskType.Fo6Scheduled]: {
                    hiddenCoverages: []
                }
            }
        }
    }
};
export const constants = brand.constants;
export const features = brand.features;
export const theme = brand.theme;
export default brand.config;
